import { render, staticRenderFns } from "./SelectTenantDialog.vue?vue&type=template&id=47ce41f1"
import script from "./SelectTenantDialog.vue?vue&type=script&lang=js"
export * from "./SelectTenantDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports